import { Preview } from "Pages/Project/Investigations/Components/Preview";

interface FilePreviewProps {
  fileId: number;
  hasPreview: boolean;
}

export const FilePreview = ({ fileId, hasPreview }: FilePreviewProps) => {
  return (
    <div style={{ maxWidth: 200 }}>
      <Preview fileId={fileId} hasPreview={hasPreview} />
    </div>
  );
};
